module.exports = __webpack_public_path__ + "img/ic_24_team_handball.9098306f.svg";